import styled, { css } from 'styled-components';

import { CalciteList, CalciteListItem } from 'components/Calcite';

export const StyledCalciteList = styled(CalciteList)`
  border: 1px solid #eaeaea;
  margin-right: -1px;
`;

export const StyledCalciteListItem = styled(CalciteListItem)`
  ${({ selected, theme }) =>
    selected &&
    css`
      --calcite-color-foreground-1: ${theme.color.background};
    `}
`;
